import { render, staticRenderFns } from "./addEmail.vue?vue&type=template&id=56a98574&scoped=true&"
import script from "./addEmail.vue?vue&type=script&lang=js&"
export * from "./addEmail.vue?vue&type=script&lang=js&"
import style0 from "./addEmail.vue?vue&type=style&index=0&id=56a98574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a98574",
  null
  
)

export default component.exports